import React from 'react';

/**
 * The screen's actions, fixed to the bottom edge where the thumb reaches, and
 * clear of the phone's home indicator. At most two: a secondary on the left
 * and the primary filling the rest. The room it covers is kept at the end of
 * the page by `OperatorLayout`, wherever a screen places the bar.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - The buttons, `size="lg"`.
 */
export const OperatorActionBar = ({ children }) => (
  <div
    data-testid="action-bar"
    className="fixed inset-x-0 bottom-0 z-30 border-t border-border bg-white px-4 pt-3 pb-[calc(0.75rem_+_env(safe-area-inset-bottom))] dark:bg-[#1a1a1a]"
  >
    <div className="mx-auto flex max-w-2xl gap-3 [&>*:last-child]:flex-1">{children}</div>
  </div>
);
